import * as React from 'react';

interface Props {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default ({ label, checked, onChange }: Props) => (
  <div className="form-check">
    <label className="form-check-label">
      <input
        className="form-check-input"
        type="checkbox"
        onChange={evt => onChange(evt.target.checked)}
        checked={checked}
      />
      <span className="form-check-sign" />
      {label}
    </label>
  </div>
);
